export const MAXIMUM_LINES = 32;

export const MAXIMUM_CHARACTERS_PER_LINE = 33;
